
import { Outlet, Link, useLocation } from 'react-router-dom';

export default function SuperAdminLayout() {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <aside className="w-64 bg-gray-900 text-white flex flex-col">
        <div className="p-6 border-b border-gray-800">
          <Link to="/sa" className="flex items-center gap-2">
            <img src="/logo.svg" alt="EasyDigitalDVD" className="h-8 w-8" />
            <span className="text-lg font-semibold">SuperAdmin</span>
          </Link>
        </div>
        <nav className="flex-1 p-4 overflow-y-auto">
          {/* Overview */}
          <Link
            to="/sa/overview"
            className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors cursor-pointer whitespace-nowrap ${
              isActive('/sa/overview') || isActive('/sa')
                ? 'bg-white text-gray-900'
                : 'text-gray-300 hover:bg-gray-800'
            }`}
          >
            <i className="ri-dashboard-line text-lg w-5 h-5 flex items-center justify-center"></i>
            <span className="font-medium">Overview</span>
          </Link>

          {/* Users */}
          <Link
            to="/sa/users"
            className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors cursor-pointer whitespace-nowrap ${
              isActive('/sa/users')
                ? 'bg-white text-gray-900'
                : 'text-gray-300 hover:bg-gray-800'
            }`}
          >
            <i className="ri-user-line text-lg w-5 h-5 flex items-center justify-center"></i>
            <span className="font-medium">Usuarios</span>
          </Link>

          {/* Streaming Online */}
          <Link
            to="/sa/projects"
            className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors cursor-pointer whitespace-nowrap ${
              isActive('/sa/projects')
                ? 'bg-white text-gray-900'
                : 'text-gray-300 hover:bg-gray-800'
            }`}
          >
            <i className="ri-film-line text-lg w-5 h-5 flex items-center justify-center"></i>
            <span className="font-medium">Streaming Online</span>
          </Link>

          {/* Payments */}
          <Link
            to="/sa/payments"
            className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors cursor-pointer whitespace-nowrap ${
              isActive('/sa/payments')
                ? 'bg-white text-gray-900'
                : 'text-gray-300 hover:bg-gray-800'
            }`}
          >
            <i className="ri-money-dollar-circle-line text-lg w-5 h-5 flex items-center justify-center"></i>
            <span className="font-medium">Pagos</span>
          </Link>

          {/* Invoicing */}
          <Link
            to="/sa/invoices"
            className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors cursor-pointer whitespace-nowrap ${
              isActive('/sa/invoices')
                ? 'bg-white text-gray-900'
                : 'text-gray-300 hover:bg-gray-800'
            }`}
          >
            <i className="ri-file-list-3-line text-lg w-5 h-5 flex items-center justify-center"></i>
            <span className="font-medium">Facturación</span>
          </Link>

          {/* Tax Rules */}
          <Link
            to="/sa/tax-rules"
            className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors cursor-pointer whitespace-nowrap ${
              isActive('/sa/tax-rules')
                ? 'bg-white text-gray-900'
                : 'text-gray-300 hover:bg-gray-800'
            }`}
          >
            <i className="ri-percent-line text-lg w-5 h-5 flex items-center justify-center"></i>
            <span className="font-medium">Reglas de Impuestos</span>
          </Link>

          {/* Divider */}
          <div className="border-t border-gray-700 my-4"></div>

          {/* Marketing Email */}
          <Link
            to="/sa/marketing/email"
            className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors cursor-pointer whitespace-nowrap ${
              isActive('/sa/marketing/email')
                ? 'bg-white text-gray-900'
                : 'text-gray-300 hover:bg-gray-800'
            }`}
          >
            <i className="ri-mail-send-line text-lg w-5 h-5 flex items-center justify-center"></i>
            <span className="font-medium">Marketing Email</span>
          </Link>

          {/* Notifications */}
          <Link
            to="/sa/marketing/notifications"
            className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors cursor-pointer whitespace-nowrap ${
              isActive('/sa/marketing/notifications')
                ? 'bg-white text-gray-900'
                : 'text-gray-300 hover:bg-gray-800'
            }`}
          >
            <i className="ri-notification-3-line text-lg w-5 h-5 flex items-center justify-center"></i>
            <span className="font-medium">Notificaciones</span>
          </Link>

          {/* Divider */}
          <div className="border-t border-gray-700 my-4"></div>

          {/* Plans */}
          <Link
            to="/sa/plans"
            className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors cursor-pointer whitespace-nowrap ${
              isActive('/sa/plans')
                ? 'bg-white text-gray-900'
                : 'text-gray-300 hover:bg-gray-800'
            }`}
          >
            <i className="ri-price-tag-3-line text-lg w-5 h-5 flex items-center justify-center"></i>
            <span className="font-medium">Planes</span>
          </Link>

          {/* Leads */}
          <Link
            to="/sa/leads"
            className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors cursor-pointer whitespace-nowrap ${
              isActive('/sa/leads')
                ? 'bg-white text-gray-900'
                : 'text-gray-300 hover:bg-gray-800'
            }`}
          >
            <i className="ri-user-add-line text-lg w-5 h-5 flex items-center justify-center"></i>
            <span className="font-medium">Leads</span>
          </Link>

          {/* Landing */}
          <Link
            to="/sa/landing"
            className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors cursor-pointer whitespace-nowrap ${
              isActive('/sa/landing')
                ? 'bg-white text-gray-900'
                : 'text-gray-300 hover:bg-gray-800'
            }`}
          >
            <i className="ri-pages-line text-lg w-5 h-5 flex items-center justify-center"></i>
            <span className="font-medium">Landing</span>
          </Link>

          {/* Divider */}
          <div className="border-t border-gray-700 my-4"></div>

          {/* Settings */}
          <Link
            to="/sa/settings"
            className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors cursor-pointer whitespace-nowrap ${
              isActive('/sa/settings')
                ? 'bg-white text-gray-900'
                : 'text-gray-300 hover:bg-gray-800'
            }`}
          >
            <i className="ri-settings-line text-lg w-5 h-5 flex items-center justify-center"></i>
            <span className="font-medium">Configuración</span>
          </Link>
        </nav>
        <div className="p-4 border-t border-gray-800">
          <Link
            to="/"
            className="flex items-center gap-3 px-4 py-3 rounded-lg text-gray-300 hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-logout-box-line text-lg w-5 h-5 flex items-center justify-center"></i>
            <span className="font-medium">Salir</span>
          </Link>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        <header className="bg-white border-b border-gray-200 px-8 py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-xl font-semibold text-gray-900">Panel SuperAdmin</h1>
            <div className="flex items-center gap-4">
              <div className="px-3 py-1 bg-red-100 text-red-700 text-xs font-medium rounded-full">
                ADMIN
              </div>
            </div>
          </div>
        </header>
        <main className="flex-1 p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
